import { computed } from 'vue'

import { useKanbanLog } from '@entities/kanban-comment'

interface KanbanLogCommentPayload {
  action: string
  value: string | null
}

interface KanbanLogCommentReturn {
  refLabel: ComputedRef<string>
  refComment: ComputedRef<string>
}

const parseComment = (raw: string | null): string => {
  if (!raw) return ''
  try {
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed === 'object' && 'comment' in parsed) {
      return String(parsed.comment ?? '')
    }
  } catch {
    // raw plain text
  }
  return raw
}

export const useKanbanLogComment = (payload: KanbanLogCommentPayload): KanbanLogCommentReturn => {
  const { getActionLabel } = useKanbanLog()

  const refLabel = computed<string>(() => getActionLabel(payload.action))
  const refComment = computed<string>(() => parseComment(payload.value))

  return {
    refLabel,
    refComment,
  }
}